import React, { useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "../components/Navbar";
import Footer from "../components/Footer";
import "../styles/Home.css";
import Intro from "../components/Intro";
import Services from "../components/Services";
import SecureChecksSection from "../components/SecureChecks";
import SignUpForm from "../components/Signup";
import Checks from "../components/Checks";
import SupportSection from "../components/Support";
import Subscribe from "../components/Subscribe";

const Home = () => {
  const location = useLocation();
  // Create refs for each section
  const sectionRefs = {
    home: useRef(null),
    services: useRef(null),
    about: useRef(null),
    contact: useRef(null),
  };

  const scrollToSection = (section) => {
    sectionRefs[section]?.current?.scrollIntoView({ behavior: "smooth" });
  };
  useEffect(() => {
    if (location.hash) {
      const sectionName = location.hash.replace("#", "");
      scrollToSection(sectionName);
    }
  }, [location]);
  return (
    <>
      <Header scrollToSection={scrollToSection} />
      <div ref={sectionRefs.home}>
        <Intro />
      </div>
      <div
        ref={sectionRefs.services}
        style={{ background: "linear-gradient(to right,rgb(229, 246, 220),rgb(202, 241, 158))" }}
      >
        <Services />
      </div>
      <div ref={sectionRefs.about}>
        <SecureChecksSection />
      </div>
      <SignUpForm />
      <Checks />
      <div ref={sectionRefs.contact} style={{ background: "linear-gradient(to right,rgb(229, 246, 220),rgb(202, 241, 158))" }}>
        <SupportSection />
      </div>
      <Subscribe />
      <Footer />
    </>
  );
};

export default Home;
